$(function() {

	/*
	 * Travel Gadget Claims Scripts
	 */

	// Show/Hide additional documents list
	$('.hidden').hide();

	$('a.additional-documents').on('click', function(e) {
		e.preventDefault();
		$(this).parent().next('.hidden').slideToggle();
		var $this = $(this);
		$this.toggleClass('collapsed expanded');
		if($this.hasClass('collapsed')){
			$this.text('Show additional documents');			
		} else {
			$this.text('Hide additional documents');
		}
	});

	// Trigger additional documents list from second link
	$('a.focus-additional-documents').on('click', function(e) {
		e.preventDefault();
		$('a.additional-documents').focus();
		$('a.additional-documents').click();
	});

	// Hamburger Icon
	$('.hamburger').on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('is-active');
		$('.responsive-menu-contents').slideToggle();
		$('.responsive-menu-contents').toggleClass('active');
		$('.responsive-menu-overlay').fadeToggle();
		preventScrollWhenMenuOpen();
	});

	// Prevent scrolling when menu is open
	function preventScrollWhenMenuOpen() {
		var navIsActive = $('.responsive-menu-contents').hasClass('active');
		if (navIsActive) {
			$('html').addClass('no-overflow');
		}
		else {
			$('html').removeClass('no-overflow');
		}
	}

	// Responsive menu
	$('.responsive-menu-contents').hide();
	$('.responsive-menu-overlay').hide();

});

//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIiwic291cmNlcyI6WyJ0cmF2ZWwtZ2FkZ2V0LWNsYWltcy5qcyJdLCJmaWxlIjoidHJhdmVsLWdhZGdldC1jbGFpbXMuanMifQ==
